import { z } from 'zod';

import type { PatchAdminV1OrgStoresIdBody, Store } from '@nucleus-commerce/api-client/admin';

/** The backend accepts 1 to 60 whole days. */
export const unpaidOrderHoldSchema = z.object({
  unpaidOrderHoldDays: z
    .string()
    .trim()
    .refine((v) => /^\d+$/.test(v) && Number(v) >= 1 && Number(v) <= 60, {
      error: 'paymentMethods:hold.validation.days',
    }),
});

export type UnpaidOrderHoldValues = z.infer<typeof unpaidOrderHoldSchema>;

export function fromUnpaidOrderHold(store: Pick<Store, 'settings'>): UnpaidOrderHoldValues {
  return { unpaidOrderHoldDays: String(store.settings.checkout.unpaidOrderHoldDays) };
}

export function toUnpaidOrderHoldPatch(values: UnpaidOrderHoldValues): PatchAdminV1OrgStoresIdBody {
  return { settings: { checkout: { unpaidOrderHoldDays: Number(values.unpaidOrderHoldDays) } } };
}
